import { ApiTopSalesRecommendationsData, ApiTopSalesTrendsData } from '../../domain/models/api-top-sales.model';

import { ProductUid } from '@shared/product/related-products/domain/models/related-products.models';

export const getTopSalesProductsIds = (products: ApiTopSalesRecommendationsData[]): number[] => {
    return products.map((product: ApiTopSalesRecommendationsData) => {
        const id = Number(product.commercial_component_id);
        return id || undefined;
    });
};

export const topSalesProductsTransformer = (products: ApiTopSalesTrendsData[]): ProductUid[] => {
    return products.map((product: ApiTopSalesTrendsData) => {
        const mcc: string = product.product.split('-')[0];
        return {
            colorId: mcc.slice(-3),
            product_id: null,
            provider: 'tinybird',
            uid: mcc.slice(0, -3),
        };
    });
};
